import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bity': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M78.4 67.2c95.4-89.2 246.1-91.2 343.1 3.8 14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zM177.3 485.8c-128.7-38.3-201.9-170.7-169.8-298.1 5.3-21 35.2-12.5 30.2 7.1-28.3 111.3 35.3 227.1 147.5 261 21.4 6.4 11.4 35.7-7.9 30zM325.4 483.8c-19.2 6.3-30-22.7-8.8-29.7 106.1-35.5 167.4-145.7 143.2-253.4-4.9-21.7 25.5-27.6 30-7.9 28.5 124.1-42.5 250.8-164.4 291zM262.5 404.8c0 8.2-6.6 14.8-14.8 14.8s-14.8-6.6-14.8-14.8l0.2-71.8c0-8.1 6.6-14.8 14.8-14.8 8.2 0 14.8 6.6 14.8 14.8zM333.5 135.8c0-21.8 32.5-19.6 32.5 0v71.6c0 69.3-60.7 90.9-118 90.1-57.3 0.8-118-20.8-118-90.1v-71.6c0-19.6 32.5-21.8 32.5 0-1.4 88.2-7 131.8 85.5 132.5 90.2-0.6 87.6-41.6 85.5-132.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bity.js
// module id = 727
// module chunks = 0